export const PT = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="24"
    viewBox="0 0 32 24"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9104_10924)">
      <path d="M12.8 0H32V24H12.8V0Z" fill="#FF0000" />
      <path d="M0 0H12.8V24H0V0Z" fill="#006600" />
      <path
        clipRule="evenodd"
        d="M16.975 15.3101C15.36 15.2601 7.97499 10.6501 7.92499 9.91011L8.32999 9.23511C9.06499 10.3001 16.615 14.7851 17.36 14.6251L16.975 15.3101Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M8.24501 9.14001C8.10001 9.53001 10.175 10.81 12.665 12.33C15.16 13.845 17.31 14.78 17.465 14.65L17.54 14.51C17.51 14.56 17.44 14.575 17.325 14.54C16.65 14.345 14.895 13.54 12.72 12.22C10.54 10.9 8.65001 9.68501 8.35501 9.17001C8.33202 9.12173 8.32169 9.06839 8.32501 9.01501H8.31501L8.25501 9.12501L8.24501 9.14001ZM17.01 15.33C16.985 15.38 16.93 15.38 16.835 15.37C16.235 15.305 14.405 14.415 12.24 13.12C9.72001 11.61 7.64001 10.24 7.87001 9.88001L7.93001 9.77001L7.94001 9.77501C7.74001 10.385 12.045 12.845 12.3 13.005C14.79 14.545 16.89 15.45 17.075 15.215L17.01 15.33Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M12.81 10.36C14.42 10.345 16.41 10.14 17.56 9.67995L17.31 9.27995C16.635 9.65495 14.635 9.90495 12.795 9.93995C10.625 9.91995 9.08997 9.71495 8.31997 9.19995L8.08997 9.62995C9.49997 10.23 10.95 10.355 12.81 10.36Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M17.625 9.69003C17.585 9.75503 16.835 10.01 15.735 10.2C14.7653 10.347 13.7858 10.4189 12.805 10.415C11.8654 10.4186 10.9265 10.3584 9.99501 10.235C8.84001 10.055 8.24501 9.80503 8.02001 9.71503L8.07501 9.60503C8.71001 9.85503 9.31001 10.005 10.01 10.115C10.9347 10.2399 11.8669 10.3017 12.8 10.3C13.7757 10.301 14.75 10.2291 15.715 10.085C16.84 9.90003 17.455 9.66503 17.545 9.56003L17.625 9.69003ZM17.405 9.28503C17.285 9.38503 16.675 9.60003 15.605 9.77003C14.681 9.90374 13.7486 9.97058 12.815 9.97003C11.715 9.97003 10.81 9.89003 10.125 9.79003C9.03501 9.65003 8.45501 9.39003 8.24501 9.32003L8.31001 9.21003C8.47501 9.29503 9.03001 9.52003 10.135 9.67503C11.0233 9.79401 11.9188 9.85082 12.815 9.84503C13.742 9.84532 14.6677 9.77847 15.585 9.64503C16.66 9.49503 17.24 9.22503 17.33 9.15503L17.405 9.28503ZM7.51501 12.3C8.50501 12.835 10.71 13.1 12.795 13.12C14.695 13.125 17.165 12.83 18.09 12.34L18.065 11.805C17.775 12.255 15.125 12.69 12.775 12.675C10.425 12.655 8.24001 12.295 7.51001 11.825V12.3"
        fill="#FFFF00"
        fillRule="evenodd"
      />
      <path
        d="M7.51501 12.3C8.50501 12.835 10.71 13.1 12.795 13.12C14.695 13.125 17.165 12.83 18.09 12.34L18.065 11.805C17.775 12.255 15.125 12.69 12.775 12.675C10.425 12.655 8.24001 12.295 7.51001 11.825V12.3M17.625 9.69003C17.585 9.75503 16.835 10.01 15.735 10.2C14.7653 10.347 13.7858 10.4189 12.805 10.415C11.8654 10.4186 10.9265 10.3584 9.99501 10.235C8.84001 10.055 8.24501 9.80503 8.02001 9.71503L8.07501 9.60503C8.71001 9.85503 9.31001 10.005 10.01 10.115C10.9347 10.2399 11.8669 10.3017 12.8 10.3C13.7757 10.301 14.75 10.2291 15.715 10.085C16.84 9.90003 17.455 9.66503 17.545 9.56003L17.625 9.69003ZM17.405 9.28503C17.285 9.38503 16.675 9.60003 15.605 9.77003C14.681 9.90374 13.7486 9.97058 12.815 9.97003C11.715 9.97003 10.81 9.89003 10.125 9.79003C9.03501 9.65003 8.45501 9.39003 8.24501 9.32003L8.31001 9.21003C8.47501 9.29503 9.03001 9.52003 10.135 9.67503C11.0233 9.79401 11.9188 9.85082 12.815 9.84503C13.742 9.84532 14.6677 9.77847 15.585 9.64503C16.66 9.49503 17.24 9.22503 17.33 9.15503L17.405 9.28503Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M18.14 12.2251V12.3501C18 12.5201 17.13 12.7701 16.04 12.9501C14.9571 13.1058 13.864 13.1793 12.77 13.1701C11.7327 13.179 10.6962 13.1071 9.67001 12.9551C8.90429 12.8666 8.15606 12.6644 7.45001 12.3551V12.2101C7.93501 12.5301 9.24501 12.7701 9.68501 12.8401C10.475 12.9601 11.49 13.0501 12.77 13.0501C14.115 13.0501 15.19 12.9551 16.02 12.8301C16.805 12.7151 17.92 12.4201 18.14 12.2251ZM18.14 11.7751V11.9001C18 12.0651 17.13 12.3151 16.04 12.4951C14.9572 12.6525 13.8641 12.7277 12.77 12.7201C11.7328 12.7262 10.6965 12.6544 9.67001 12.5051C8.90429 12.4166 8.15606 12.2144 7.45001 11.9051V11.7551C7.93501 12.0801 9.25001 12.3151 9.68501 12.3851C10.7064 12.5347 11.7377 12.6066 12.77 12.6001C14.115 12.6001 15.195 12.5001 16.02 12.3751C16.805 12.2651 17.92 11.9701 18.14 11.7751ZM12.79 15.2151C10.51 15.2051 8.55501 14.5951 8.14001 14.4951L8.44001 14.9651C9.84247 15.4618 11.3224 15.704 12.81 15.6801C14.545 15.6301 16.06 15.4951 17.125 14.9751L17.435 14.4851C16.71 14.8301 14.235 15.2151 12.785 15.2151"
        fill="#FFFF00"
        fillRule="evenodd"
      />
      <path
        d="M12.79 15.2151C10.51 15.2051 8.55501 14.5951 8.14001 14.4951L8.44001 14.9651C9.84247 15.4618 11.3224 15.704 12.81 15.6801C14.545 15.6301 16.06 15.4951 17.125 14.9751L17.435 14.4851C16.71 14.8301 14.235 15.2151 12.785 15.2151M18.14 12.2251V12.3501C18 12.5201 17.13 12.7701 16.04 12.9501C14.9571 13.1058 13.864 13.1793 12.77 13.1701C11.7327 13.179 10.6962 13.1071 9.67001 12.9551C8.90429 12.8666 8.15606 12.6644 7.45001 12.3551V12.2101C7.93501 12.5301 9.24501 12.7701 9.68501 12.8401C10.475 12.9601 11.49 13.0501 12.77 13.0501C14.115 13.0501 15.19 12.9551 16.02 12.8301C16.805 12.7151 17.92 12.4201 18.14 12.2251ZM18.14 11.7751V11.9001C18 12.0651 17.13 12.3151 16.04 12.4951C14.9572 12.6525 13.8641 12.7277 12.77 12.7201C11.7328 12.7262 10.6965 12.6544 9.67001 12.5051C8.90429 12.4166 8.15606 12.2144 7.45001 11.9051V11.7551C7.93501 12.0801 9.25001 12.3151 9.68501 12.3851C10.7064 12.5347 11.7377 12.6066 12.77 12.6001C14.115 12.6001 15.195 12.5001 16.02 12.3751C16.805 12.2651 17.92 11.9701 18.14 11.7751Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M17.245 14.865C17.1995 14.9325 17.1528 14.9992 17.105 15.065C16.605 15.245 15.805 15.435 15.475 15.485C14.5895 15.65 13.6907 15.7337 12.79 15.735C10.77 15.705 9.11499 15.31 8.33999 14.97L8.27499 14.865L8.28499 14.845L8.38999 14.89C9.813 15.3609 11.3011 15.6056 12.8 15.615C13.74 15.615 14.675 15.51 15.43 15.375C16.59 15.14 17.06 14.965 17.205 14.885L17.24 14.865H17.245ZM17.51 14.425C17.4771 14.4836 17.4437 14.5419 17.41 14.6C17.14 14.7 16.41 14.91 15.345 15.06C14.645 15.155 14.21 15.25 12.815 15.275C11.2203 15.259 9.63541 15.0235 8.10499 14.575L8.04999 14.45C9.60491 14.8798 11.2072 15.1149 12.82 15.15C14.095 15.125 14.64 15.03 15.335 14.935C16.575 14.745 17.2 14.535 17.385 14.48C17.3851 14.4767 17.3851 14.4734 17.385 14.47L17.515 14.42L17.51 14.425Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M17.54 11.88C17.545 13.38 16.775 14.73 16.16 15.32C15.2517 16.2059 14.0387 16.7104 12.77 16.73C11.255 16.755 9.83002 15.77 9.44502 15.335C8.58373 14.4216 8.09353 13.2202 8.07002 11.965C8.16002 10.325 8.80502 9.185 9.73502 8.4C10.6384 7.65629 11.7749 7.25445 12.945 7.265C13.6281 7.29812 14.2967 7.47356 14.908 7.78008C15.5193 8.0866 16.0599 8.51744 16.495 9.045C17.12 9.805 17.395 10.63 17.54 11.88ZM12.78 6.75C14.1788 6.74996 15.5208 7.30286 16.5136 8.28817C17.5064 9.27347 18.0695 10.6113 18.08 12.01C18.08 12.704 17.9433 13.3913 17.6777 14.0325C17.4121 14.6737 17.0228 15.2563 16.5321 15.7471C16.0413 16.2378 15.4587 16.6271 14.8175 16.8927C14.1763 17.1583 13.4891 17.295 12.795 17.295C12.101 17.295 11.4137 17.1583 10.7725 16.8927C10.1313 16.6271 9.54872 16.2378 9.05796 15.7471C8.5672 15.2563 8.17791 14.6737 7.91231 14.0325C7.64672 13.3913 7.51002 12.704 7.51002 12.01C7.50502 9.11 9.87502 6.75 12.78 6.75Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M12.795 6.72498C15.705 6.72498 18.075 9.09498 18.075 12.005C18.075 14.915 15.705 17.285 12.8 17.285C9.89502 17.285 7.52002 14.915 7.52002 12.005C7.52002 9.09498 9.89002 6.72498 12.8 6.72498H12.795ZM7.63002 12C7.63002 14.84 9.96502 17.165 12.795 17.165C15.625 17.165 17.96 14.84 17.96 12C17.96 9.15998 15.625 6.83498 12.795 6.83498C9.96502 6.83498 7.63002 9.15998 7.63002 12Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M12.8 7.16504C14.0811 7.169 15.3086 7.67967 16.2145 8.58555C17.1203 9.49143 17.631 10.7189 17.635 12C17.631 13.2816 17.1205 14.5096 16.2148 15.4163C15.309 16.323 14.0815 16.8348 12.8 16.84C10.15 16.84 7.96497 14.66 7.96497 12C7.97023 10.7193 8.48132 9.49259 9.38692 8.58699C10.2925 7.68139 11.5193 7.1703 12.8 7.16504ZM8.07997 12C8.07997 14.6 10.21 16.72 12.8 16.72C15.39 16.72 17.52 14.595 17.52 12C17.52 9.40004 15.39 7.28004 12.8 7.28004C11.5498 7.2853 10.3523 7.78428 9.46824 8.66831C8.5842 9.55234 8.08523 10.7498 8.07997 12Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M13.015 6.69995H12.56V17.315H13.01L13.015 6.69995Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M12.965 6.64001H13.08V17.375H12.97V6.64001H12.965ZM12.515 6.64001H12.635V17.375H12.52L12.515 6.64001Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M18.08 12.21V11.82L17.76 11.52L15.945 11.04L13.335 10.775L10.185 10.935L7.945 11.465L7.495 11.8V12.195L8.64 11.68L11.36 11.255H13.975L15.895 11.465L17.225 11.785L18.08 12.21Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M12.8 11.1901C14.045 11.1901 15.25 11.3051 16.215 11.4901C17.205 11.6901 17.9 11.9401 18.14 12.2151V12.3551C17.85 12.0051 16.915 11.7551 16.19 11.6051C15.24 11.4251 14.04 11.3051 12.795 11.3051C11.49 11.3051 10.27 11.4351 9.33001 11.6151C8.58001 11.7651 7.57501 12.0651 7.45001 12.3551V12.2101C7.51501 12.0101 8.26501 11.7101 9.31501 11.4951C10.26 11.3101 11.48 11.1901 12.795 11.1901H12.8ZM12.8 10.7351C13.945 10.7328 15.0879 10.8332 16.215 11.0351C17.205 11.2351 17.9 11.4851 18.14 11.7651V11.9001C17.85 11.5551 16.915 11.3001 16.19 11.1551C15.24 10.9701 14.04 10.8551 12.795 10.8551C11.6346 10.8514 10.4763 10.9552 9.33501 11.1651C8.61001 11.3001 7.56501 11.6101 7.45001 11.9001V11.7601C7.52001 11.5601 8.28001 11.2451 9.31501 11.0451C10.265 10.8601 11.48 10.7351 12.8 10.7351ZM12.77 8.42506C14.735 8.41506 16.45 8.70006 17.235 9.10006L17.52 9.60006C16.84 9.23006 14.99 8.85006 12.775 8.90006C10.97 8.91506 9.04001 9.10006 8.07501 9.62006L8.41501 9.05006C9.21001 8.63506 11.08 8.42506 12.77 8.42506Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M12.8 8.83509C13.8259 8.81778 14.8515 8.88971 15.865 9.05009C16.665 9.20009 17.43 9.42009 17.54 9.54009L17.625 9.69009C17.36 9.52009 16.695 9.32509 15.845 9.16509C14.995 9.00509 13.91 8.95009 12.795 8.95509C11.53 8.95009 10.545 9.01509 9.70498 9.16509C9.12593 9.24624 8.56373 9.42014 8.03998 9.68009L8.12498 9.52509C8.42498 9.37509 8.88998 9.19009 9.67998 9.04509C10.555 8.88509 11.55 8.84009 12.8 8.83509ZM12.8 8.38509C13.87 8.37509 14.93 8.43509 15.755 8.58509C16.2895 8.66444 16.8068 8.83349 17.285 9.08509L17.41 9.28509C17.2 9.05009 16.41 8.82509 15.705 8.70509C14.885 8.56009 13.87 8.50509 12.8 8.49509C11.8039 8.48621 10.8089 8.55979 9.82498 8.71509C9.31052 8.78677 8.81086 8.94038 8.34498 9.17009L8.45498 9.00509C8.74498 8.85509 9.21498 8.71509 9.80498 8.60009C10.7954 8.44276 11.7972 8.36916 12.8 8.38009V8.38509ZM15.42 14.2001C14.5533 14.05 13.6743 13.9831 12.795 14.0001C9.51998 14.0401 8.46498 14.6751 8.33498 14.8651L8.08498 14.4651C8.92498 13.8651 10.705 13.5251 12.815 13.5551C13.91 13.5751 14.855 13.6501 15.645 13.8051L15.42 14.2051"
        fill="#FFFF00"
        fillRule="evenodd"
      />
      <path
        d="M15.42 14.2001C14.5533 14.05 13.6743 13.9831 12.795 14.0001C9.51998 14.0401 8.46498 14.6751 8.33498 14.8651L8.08498 14.4651C8.92498 13.8651 10.705 13.5251 12.815 13.5551C13.91 13.5751 14.855 13.6501 15.645 13.8051L15.42 14.2051M12.8 8.83509C13.8259 8.81778 14.8515 8.88971 15.865 9.05009C16.665 9.20009 17.43 9.42009 17.54 9.54009L17.625 9.69009C17.36 9.52009 16.695 9.32509 15.845 9.16509C14.995 9.00509 13.91 8.95009 12.795 8.95509C11.53 8.95009 10.545 9.01509 9.70498 9.16509C9.12593 9.24624 8.56373 9.42014 8.03998 9.68009L8.12498 9.52509C8.42498 9.37509 8.88998 9.19009 9.67998 9.04509C10.555 8.88509 11.55 8.84009 12.8 8.83509ZM12.8 8.38509C13.87 8.37509 14.93 8.43509 15.755 8.58509C16.2895 8.66444 16.8068 8.83349 17.285 9.08509L17.41 9.28509C17.2 9.05009 16.41 8.82509 15.705 8.70509C14.885 8.56009 13.87 8.50509 12.8 8.49509C11.8039 8.48621 10.8089 8.55979 9.82498 8.71509C9.31052 8.78677 8.81086 8.94038 8.34498 9.17009L8.45498 9.00509C8.74498 8.85509 9.21498 8.71509 9.80498 8.60009C10.7954 8.44276 11.7972 8.36916 12.8 8.38009V8.38509Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M12.78 13.9451C13.69 13.9601 14.58 13.9951 15.445 14.1551L15.385 14.2651C14.585 14.1151 13.725 14.0651 12.785 14.0651C11.57 14.0551 10.35 14.1701 9.28504 14.4751C8.95004 14.5701 8.39504 14.7851 8.33504 14.9651L8.27504 14.8651C8.29504 14.7551 8.62504 14.5351 9.25504 14.3651C10.475 14.0151 11.615 13.9501 12.78 13.9451ZM12.82 13.4851C13.7805 13.4841 14.7392 13.5678 15.685 13.7351L15.62 13.8501C14.6965 13.6807 13.759 13.5987 12.82 13.6051C11.61 13.6051 10.325 13.6951 9.15504 14.0351C8.78004 14.1451 8.12504 14.3851 8.10504 14.5701L8.04504 14.4601C8.05504 14.2901 8.62004 14.0651 9.13004 13.9201C10.305 13.5751 11.595 13.4901 12.82 13.4851Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M17.47 14.525L17.08 15.14L15.945 14.135L13.015 12.16L9.70499 10.345L7.98999 9.76001L8.35499 9.08001L8.47999 9.01501L9.54499 9.28001L13.065 11.095L15.095 12.375L16.8 13.6L17.495 14.4L17.47 14.525Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        clipRule="evenodd"
        d="M7.92999 9.77505C8.22999 9.57505 10.44 10.5551 12.76 11.9551C15.065 13.3551 17.275 14.9351 17.075 15.2301L17.01 15.3351L16.98 15.3601C16.985 15.3551 17.02 15.3101 16.98 15.2051C16.88 14.8801 15.31 13.6301 12.715 12.0601C10.18 10.5551 8.06999 9.64505 7.86499 9.90505L7.92999 9.77505ZM17.55 14.5201C17.74 14.1401 15.69 12.5951 13.145 11.0901C10.545 9.61505 8.66499 8.74505 8.31999 9.00505L8.24999 9.15005C8.24999 9.15505 8.24999 9.14005 8.26999 9.12505C8.32999 9.07505 8.43499 9.07505 8.47999 9.07505C9.06999 9.08505 10.755 9.86005 13.12 11.2151C14.16 11.8151 17.5 13.9651 17.485 14.5651C17.485 14.6151 17.49 14.6251 17.47 14.6551L17.555 14.5251L17.55 14.5201Z"
        fill="#FFFF00"
        fillRule="evenodd"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.03"
      />
      <path
        d="M9.63202 12.5884C9.63281 13.0024 9.71571 13.4121 9.87592 13.7938C10.0361 14.1756 10.2705 14.5218 10.5654 14.8124C10.8567 15.1081 11.2036 15.3434 11.5862 15.5045C11.9688 15.6656 12.3796 15.7494 12.7947 15.751C13.6349 15.751 14.4406 15.4172 15.0347 14.823C15.3286 14.5308 15.5618 14.1835 15.7211 13.8009C15.8803 13.4183 15.9624 13.0081 15.9627 12.5937V8.36968L9.63202 8.35901V12.5884Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0373334"
      />
      <path
        d="M9.76001 12.5937C9.76114 12.9908 9.84089 13.3838 9.99468 13.75C10.1485 14.1161 10.3732 14.4482 10.656 14.727C11.2238 15.2978 11.9949 15.6201 12.8 15.623C13.6037 15.6235 14.3748 15.3051 14.944 14.7377C15.2258 14.4584 15.4496 14.1261 15.6025 13.76C15.7554 13.3939 15.8343 13.0011 15.8347 12.6044V8.49768H9.76001V12.5937ZM14.6134 9.72968V12.3377L14.608 12.6097C14.6098 12.848 14.5635 13.0841 14.4719 13.3041C14.3802 13.524 14.2451 13.7232 14.0747 13.8897C13.7355 14.23 13.2752 14.4219 12.7947 14.423C12.2934 14.423 11.8507 14.2097 11.52 13.879C11.1797 13.5399 10.9879 13.0795 10.9867 12.599V9.71902L14.6134 9.72968Z"
        fill="#FF0000"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.144 9.56958C10.1493 9.27624 10.3573 9.20691 10.3573 9.20691C10.3626 9.20691 10.5867 9.28158 10.5867 9.57491L10.144 9.56958Z"
        fill="#FFFF00"
      />
      <path
        d="M9.96265 9.21224L9.92532 9.54824H10.1493C10.1493 9.27091 10.3627 9.22824 10.3627 9.22824C10.368 9.22824 10.576 9.28691 10.5813 9.54824H10.8053L10.7627 9.20691L9.96265 9.21224ZM9.90932 9.55358H10.816C10.832 9.55358 10.848 9.56958 10.848 9.59091C10.848 9.61758 10.832 9.63358 10.816 9.63358H9.90932C9.89332 9.63358 9.87732 9.61758 9.87732 9.59091C9.87732 9.56958 9.89332 9.55358 9.91465 9.55358H9.90932Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.24 9.54831C10.24 9.37231 10.3627 9.32431 10.3627 9.32431C10.3627 9.32431 10.4854 9.37764 10.4854 9.54831H10.24ZM9.93068 9.0683H10.8C10.816 9.0683 10.832 9.08964 10.832 9.11097C10.832 9.12697 10.816 9.14297 10.8 9.14297H9.93068C9.91468 9.14297 9.89868 9.12697 9.89868 9.10564C9.89868 9.08964 9.91468 9.07364 9.93068 9.07364V9.0683ZM9.95202 9.14831H10.7734C10.7894 9.14831 10.8054 9.1643 10.8054 9.18564C10.8054 9.20697 10.7894 9.22297 10.7734 9.22297H9.94668C9.92535 9.22297 9.91468 9.20697 9.91468 9.18564C9.91468 9.1643 9.92535 9.14831 9.94668 9.14831H9.95202ZM10.2187 8.58297H10.2827V8.62564H10.3307V8.58297H10.4V8.63097H10.448V8.57764H10.512V8.6843C10.512 8.70564 10.5014 8.7163 10.4854 8.7163H10.2507C10.2347 8.7163 10.2187 8.70564 10.2187 8.68964V8.58297ZM10.464 8.72697L10.48 9.0683H10.2507L10.2667 8.72164H10.464"
        fill="#FFFF00"
      />
      <path
        d="M10.464 8.72697L10.48 9.0683H10.2507L10.2667 8.72164H10.464M10.24 9.54831C10.24 9.37231 10.3627 9.32431 10.3627 9.32431C10.3627 9.32431 10.4854 9.37764 10.4854 9.54831H10.24ZM9.93068 9.0683H10.8C10.816 9.0683 10.832 9.08964 10.832 9.11097C10.832 9.12697 10.816 9.14297 10.8 9.14297H9.93068C9.91468 9.14297 9.89868 9.12697 9.89868 9.10564C9.89868 9.08964 9.91468 9.07364 9.93068 9.07364V9.0683ZM9.95202 9.14831H10.7734C10.7894 9.14831 10.8054 9.1643 10.8054 9.18564C10.8054 9.20697 10.7894 9.22297 10.7734 9.22297H9.94668C9.92535 9.22297 9.91468 9.20697 9.91468 9.18564C9.91468 9.1643 9.92535 9.14831 9.94668 9.14831H9.95202ZM10.2187 8.58297H10.2827V8.62564H10.3307V8.58297H10.4V8.63097H10.448V8.57764H10.512V8.6843C10.512 8.70564 10.5014 8.7163 10.4854 8.7163H10.2507C10.2347 8.7163 10.2187 8.70564 10.2187 8.68964V8.58297Z"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.1867 8.88696V9.0683H9.97333V8.88696H10.1867Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.752 8.88696V9.0683H10.5387V8.88696H10.752Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M9.93604 8.74829H10V8.80162H10.048V8.74829H10.112V8.80162H10.16V8.74829H10.224V8.85496C10.224 8.87629 10.2134 8.88696 10.1974 8.88696H9.96803C9.95955 8.88696 9.95141 8.88359 9.94541 8.87759C9.93941 8.87158 9.93604 8.86344 9.93604 8.85496V8.74829Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.5013 8.74829H10.5653V8.80162H10.6133V8.74829H10.6773V8.80162H10.7253V8.74829H10.7893V8.85496C10.7893 8.87629 10.7787 8.88696 10.7627 8.88696H10.5333C10.5249 8.88696 10.5167 8.88359 10.5107 8.87759C10.5047 8.87158 10.5013 8.86344 10.5013 8.85496V8.74829Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.3414 8.83369C10.3414 8.80169 10.3894 8.80169 10.3894 8.83369V8.91903H10.3414V8.83369Z"
        fill="#000001"
      />
      <path
        d="M10.0587 8.951C10.0587 8.919 10.1014 8.919 10.1014 8.951V9.015H10.0587V8.951Z"
        fill="#000001"
      />
      <path
        d="M10.624 8.951C10.624 8.919 10.6667 8.919 10.6667 8.951V9.015H10.624V8.951Z"
        fill="#000001"
      />
      <path
        d="M10.144 12.0389C10.1493 11.7456 10.3573 11.6763 10.3573 11.6763C10.3626 11.6763 10.5867 11.7509 10.5867 12.0443L10.144 12.0389Z"
        fill="#FFFF00"
      />
      <path
        d="M9.96265 11.6816L9.92532 12.0176H10.1493C10.1493 11.7403 10.3627 11.6976 10.3627 11.6976C10.368 11.6976 10.576 11.7563 10.5813 12.0176H10.8053L10.7627 11.6763L9.96265 11.6816ZM9.90932 12.0229H10.816C10.832 12.0229 10.848 12.0389 10.848 12.0603C10.848 12.0869 10.832 12.1029 10.816 12.1029H9.90932C9.89332 12.1029 9.87732 12.0869 9.87732 12.0603C9.87732 12.0389 9.89332 12.0229 9.91465 12.0229H9.90932Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.24 12.0177C10.24 11.8417 10.3627 11.7937 10.3627 11.7937C10.3627 11.7937 10.4854 11.847 10.4854 12.0177H10.24ZM9.93068 11.5377H10.8C10.816 11.5377 10.832 11.559 10.832 11.5803C10.832 11.5963 10.816 11.6123 10.8 11.6123H9.93068C9.91468 11.6123 9.89868 11.5963 9.89868 11.575C9.89868 11.559 9.91468 11.543 9.93068 11.543V11.5377ZM9.95202 11.6177H10.7734C10.7894 11.6177 10.8054 11.6337 10.8054 11.655C10.8054 11.6763 10.7894 11.6923 10.7734 11.6923H9.94668C9.92535 11.6923 9.91468 11.6763 9.91468 11.655C9.91468 11.6337 9.92535 11.6177 9.94668 11.6177H9.95202ZM10.2187 11.0523H10.2827V11.095H10.3307V11.0523H10.4V11.1003H10.448V11.047H10.512V11.1537C10.512 11.175 10.5014 11.1857 10.4854 11.1857H10.2507C10.2347 11.1857 10.2187 11.175 10.2187 11.159V11.0523ZM10.464 11.1963L10.48 11.5377H10.2507L10.2667 11.191H10.464"
        fill="#FFFF00"
      />
      <path
        d="M10.464 11.1963L10.48 11.5377H10.2507L10.2667 11.191H10.464M10.24 12.0177C10.24 11.8417 10.3627 11.7937 10.3627 11.7937C10.3627 11.7937 10.4854 11.847 10.4854 12.0177H10.24ZM9.93068 11.5377H10.8C10.816 11.5377 10.832 11.559 10.832 11.5803C10.832 11.5963 10.816 11.6123 10.8 11.6123H9.93068C9.91468 11.6123 9.89868 11.5963 9.89868 11.575C9.89868 11.559 9.91468 11.543 9.93068 11.543V11.5377ZM9.95202 11.6177H10.7734C10.7894 11.6177 10.8054 11.6337 10.8054 11.655C10.8054 11.6763 10.7894 11.6923 10.7734 11.6923H9.94668C9.92535 11.6923 9.91468 11.6763 9.91468 11.655C9.91468 11.6337 9.92535 11.6177 9.94668 11.6177H9.95202ZM10.2187 11.0523H10.2827V11.095H10.3307V11.0523H10.4V11.1003H10.448V11.047H10.512V11.1537C10.512 11.175 10.5014 11.1857 10.4854 11.1857H10.2507C10.2347 11.1857 10.2187 11.175 10.2187 11.159V11.0523Z"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.1867 11.3563V11.5377H9.97333V11.3563H10.1867Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.752 11.3563V11.5377H10.5387V11.3563H10.752Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M9.93604 11.2177H10V11.271H10.048V11.2177H10.112V11.271H10.16V11.2177H10.224V11.3243C10.224 11.3457 10.2134 11.3563 10.1974 11.3563H9.96803C9.95955 11.3563 9.95141 11.3529 9.94541 11.3469C9.93941 11.3409 9.93604 11.3328 9.93604 11.3243V11.2177Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.5013 11.2177H10.5653V11.271H10.6133V11.2177H10.6773V11.271H10.7253V11.2177H10.7893V11.3243C10.7893 11.3457 10.7787 11.3563 10.7627 11.3563H10.5333C10.5249 11.3563 10.5167 11.3529 10.5107 11.3469C10.5047 11.3409 10.5013 11.3328 10.5013 11.3243V11.2177Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.3414 11.3031C10.3414 11.2711 10.3894 11.2711 10.3894 11.3031V11.3884H10.3414V11.3031Z"
        fill="#000001"
      />
      <path
        d="M10.0587 11.4202C10.0587 11.3882 10.1014 11.3882 10.1014 11.4202V11.4842H10.0587V11.4202Z"
        fill="#000001"
      />
      <path
        d="M10.624 11.4202C10.624 11.3882 10.6667 11.3882 10.6667 11.4202V11.4842H10.624V11.4202Z"
        fill="#000001"
      />
      <path
        d="M11.1065 14.6126C10.9021 14.4021 10.9995 14.2057 10.9995 14.2057C11.0033 14.2019 11.2141 14.0956 11.4222 14.3023L11.1065 14.6126Z"
        fill="#FFFF00"
      />
      <path
        d="M10.7252 14.4895L10.9373 14.7527L11.0951 14.5938C10.8983 14.3984 11.0184 14.2169 11.0184 14.2169C11.0221 14.2131 11.2103 14.1069 11.3995 14.2872L11.5574 14.1283L11.2851 13.9181L10.7252 14.4895ZM10.9298 14.7678L11.5687 14.1245C11.5799 14.1131 11.6026 14.1131 11.6177 14.1281C11.6366 14.1469 11.6367 14.1695 11.6254 14.1809L10.9866 14.8242C10.9753 14.8356 10.9527 14.8356 10.9337 14.8168C10.9186 14.8018 10.9185 14.7792 10.9335 14.764L10.9298 14.7678Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M11.159 14.5294C11.0341 14.4054 11.0865 14.2845 11.0865 14.2845C11.0865 14.2845 11.2108 14.2351 11.3319 14.3553L11.159 14.5294ZM10.6004 14.4107L11.213 13.7938C11.2243 13.7825 11.2507 13.7862 11.2658 13.8012C11.2772 13.8125 11.2773 13.8351 11.266 13.8464L10.6534 14.4633C10.6422 14.4746 10.6195 14.4747 10.6044 14.4597C10.593 14.4484 10.593 14.4258 10.6042 14.4144L10.6004 14.4107ZM10.6722 14.4519L11.251 13.8691C11.2623 13.8578 11.2849 13.8577 11.3 13.8727C11.3152 13.8878 11.3152 13.9104 11.304 13.9217L10.7215 14.5083C10.7064 14.5234 10.6876 14.5197 10.6724 14.5047C10.6573 14.4897 10.6535 14.4708 10.6685 14.4557L10.6722 14.4519ZM10.459 13.8643L10.5041 13.8189L10.5344 13.849L10.5682 13.8149L10.5379 13.7849L10.5868 13.7357L10.6208 13.7695L10.6547 13.7354L10.6168 13.6979L10.6619 13.6524L10.7376 13.7276C10.7527 13.7426 10.7528 13.7577 10.7415 13.7691L10.5762 13.9356C10.5649 13.9469 10.546 13.9508 10.5347 13.9395L10.459 13.8643ZM10.7341 13.7917L10.9875 14.0209L10.8259 14.1836L10.5912 13.928L10.7303 13.788"
        fill="#FFFF00"
      />
      <path
        d="M10.7341 13.7917L10.9875 14.0209L10.8259 14.1836L10.5912 13.928L10.7303 13.788M11.159 14.5294C11.0341 14.4054 11.0865 14.2845 11.0865 14.2845C11.0865 14.2845 11.2108 14.2351 11.3319 14.3553L11.159 14.5294ZM10.6004 14.4107L11.213 13.7938C11.2243 13.7825 11.2507 13.7862 11.2658 13.8012C11.2772 13.8125 11.2773 13.8351 11.266 13.8464L10.6534 14.4633C10.6422 14.4746 10.6195 14.4747 10.6044 14.4597C10.593 14.4484 10.593 14.4258 10.6042 14.4144L10.6004 14.4107ZM10.6722 14.4519L11.251 13.8691C11.2623 13.8578 11.2849 13.8577 11.3 13.8727C11.3152 13.8878 11.3152 13.9104 11.304 13.9217L10.7215 14.5083C10.7064 14.5234 10.6876 14.5197 10.6724 14.5047C10.6573 14.4897 10.6535 14.4708 10.6685 14.4557L10.6722 14.4519ZM10.459 13.8643L10.5041 13.8189L10.5344 13.849L10.5682 13.8149L10.5379 13.7849L10.5868 13.7357L10.6208 13.7695L10.6547 13.7354L10.6168 13.6979L10.6619 13.6524L10.7376 13.7276C10.7527 13.7426 10.7528 13.7577 10.7415 13.7691L10.5762 13.9356C10.5649 13.9469 10.546 13.9508 10.5347 13.9395L10.459 13.8643Z"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.6522 14.1013L10.7808 14.2291L10.6305 14.3805L10.5018 14.2527L10.6522 14.1013Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M11.0505 13.7002L11.1792 13.828L11.0289 13.9793L10.9002 13.8516L11.0505 13.7002Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.3771 14.1814L10.4222 14.136L10.4601 14.1736L10.4939 14.1395L10.4561 14.1019L10.5012 14.0565L10.539 14.0941L10.5728 14.06L10.535 14.0225L10.5801 13.977L10.6558 14.0522C10.6709 14.0672 10.6709 14.0823 10.6597 14.0937L10.4981 14.2564C10.4921 14.2624 10.484 14.2658 10.4755 14.2659C10.467 14.2659 10.4588 14.2625 10.4528 14.2566L10.3771 14.1814Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.7755 13.7803L10.8206 13.7349L10.8585 13.7724L10.8923 13.7384L10.8544 13.7008L10.8995 13.6554L10.9374 13.693L10.9712 13.6589L10.9334 13.6213L10.9784 13.5759L11.0541 13.6511C11.0693 13.6661 11.0693 13.6812 11.0581 13.6925L10.8965 13.8553C10.8905 13.8613 10.8823 13.8647 10.8739 13.8647C10.8654 13.8648 10.8572 13.8614 10.8512 13.8554L10.7755 13.7803Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M10.7233 13.954C10.7006 13.9315 10.7344 13.8974 10.7571 13.92L10.8176 13.9801L10.7838 14.0142L10.7233 13.954Z"
        fill="#000001"
      />
      <path
        d="M10.6074 14.2372C10.5847 14.2147 10.6147 14.1844 10.6374 14.207L10.6828 14.2521L10.6528 14.2823L10.6074 14.2372Z"
        fill="#000001"
      />
      <path
        d="M11.0057 13.836C10.983 13.8135 11.0131 13.7832 11.0358 13.8057L11.0812 13.8508L11.0512 13.8811L11.0057 13.836Z"
        fill="#000001"
      />
      <path
        d="M12.5814 9.56958C12.5867 9.27624 12.7947 9.20691 12.7947 9.20691C12.8 9.20691 13.024 9.28158 13.024 9.57491L12.5814 9.56958Z"
        fill="#FFFF00"
      />
      <path
        d="M12.4 9.21224L12.3627 9.54824H12.5867C12.5867 9.27091 12.8 9.22824 12.8 9.22824C12.8054 9.22824 13.0134 9.28691 13.0187 9.54824H13.2427L13.2 9.20691L12.4 9.21224ZM12.3467 9.55358H13.2534C13.2694 9.55358 13.2854 9.56958 13.2854 9.59091C13.2854 9.61758 13.2694 9.63358 13.2534 9.63358H12.3467C12.3307 9.63358 12.3147 9.61758 12.3147 9.59091C12.3147 9.56958 12.3307 9.55358 12.352 9.55358H12.3467Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M12.6774 9.54831C12.6774 9.37231 12.8001 9.32431 12.8001 9.32431C12.8001 9.32431 12.9227 9.37764 12.9227 9.54831H12.6774ZM12.3681 9.0683H13.2374C13.2534 9.0683 13.2694 9.08964 13.2694 9.11097C13.2694 9.12697 13.2534 9.14297 13.2374 9.14297H12.3681C12.3521 9.14297 12.3361 9.12697 12.3361 9.10564C12.3361 9.08964 12.3521 9.07364 12.3681 9.07364V9.0683ZM12.3894 9.14831H13.2107C13.2267 9.14831 13.2427 9.1643 13.2427 9.18564C13.2427 9.20697 13.2267 9.22297 13.2107 9.22297H12.3841C12.3627 9.22297 12.3521 9.20697 12.3521 9.18564C12.3521 9.1643 12.3627 9.14831 12.3841 9.14831H12.3894ZM12.6561 8.58297H12.7201V8.62564H12.7681V8.58297H12.8374V8.63097H12.8854V8.57764H12.9494V8.6843C12.9494 8.70564 12.9387 8.7163 12.9227 8.7163H12.6881C12.6721 8.7163 12.6561 8.70564 12.6561 8.68964V8.58297ZM12.9014 8.72697L12.9174 9.0683H12.6881L12.7041 8.72164H12.9014"
        fill="#FFFF00"
      />
      <path
        d="M12.9014 8.72697L12.9174 9.0683H12.6881L12.7041 8.72164H12.9014M12.6774 9.54831C12.6774 9.37231 12.8001 9.32431 12.8001 9.32431C12.8001 9.32431 12.9227 9.37764 12.9227 9.54831H12.6774ZM12.3681 9.0683H13.2374C13.2534 9.0683 13.2694 9.08964 13.2694 9.11097C13.2694 9.12697 13.2534 9.14297 13.2374 9.14297H12.3681C12.3521 9.14297 12.3361 9.12697 12.3361 9.10564C12.3361 9.08964 12.3521 9.07364 12.3681 9.07364V9.0683ZM12.3894 9.14831H13.2107C13.2267 9.14831 13.2427 9.1643 13.2427 9.18564C13.2427 9.20697 13.2267 9.22297 13.2107 9.22297H12.3841C12.3627 9.22297 12.3521 9.20697 12.3521 9.18564C12.3521 9.1643 12.3627 9.14831 12.3841 9.14831H12.3894ZM12.6561 8.58297H12.7201V8.62564H12.7681V8.58297H12.8374V8.63097H12.8854V8.57764H12.9494V8.6843C12.9494 8.70564 12.9387 8.7163 12.9227 8.7163H12.6881C12.6721 8.7163 12.6561 8.70564 12.6561 8.68964V8.58297Z"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M12.624 8.88696V9.0683H12.4107V8.88696H12.624Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M13.1893 8.88696V9.0683H12.976V8.88696H13.1893Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M12.3734 8.74829H12.4374V8.80162H12.4854V8.74829H12.5494V8.80162H12.5974V8.74829H12.6614V8.85496C12.6614 8.87629 12.6507 8.88696 12.6347 8.88696H12.4054C12.3969 8.88696 12.3888 8.88359 12.3828 8.87759C12.3768 8.87158 12.3734 8.86344 12.3734 8.85496V8.74829Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M12.9387 8.74829H13.0027V8.80162H13.0507V8.74829H13.1147V8.80162H13.1627V8.74829H13.2267V8.85496C13.2267 8.87629 13.2161 8.88696 13.2001 8.88696H12.9707C12.9622 8.88696 12.9541 8.88359 12.9481 8.87759C12.9421 8.87158 12.9387 8.86344 12.9387 8.85496V8.74829Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M12.7787 8.83369C12.7787 8.80169 12.8267 8.80169 12.8267 8.83369V8.91903H12.7787V8.83369Z"
        fill="#000001"
      />
      <path
        d="M12.496 8.951C12.496 8.919 12.5387 8.919 12.5387 8.951V9.015H12.496V8.951Z"
        fill="#000001"
      />
      <path
        d="M13.0614 8.951C13.0614 8.919 13.1041 8.919 13.1041 8.951V9.015H13.0614V8.951Z"
        fill="#000001"
      />
      <path
        d="M15.4454 9.56958C15.4401 9.27624 15.2321 9.20691 15.2321 9.20691C15.2268 9.20691 15.0028 9.28158 15.0028 9.57491L15.4454 9.56958Z"
        fill="#FFFF00"
      />
      <path
        d="M15.6267 9.21224L15.664 9.54824H15.44C15.44 9.27091 15.2267 9.22824 15.2267 9.22824C15.2214 9.22824 15.0134 9.28691 15.008 9.54824H14.784L14.8267 9.20691L15.6267 9.21224ZM15.68 9.55358H14.7734C14.7574 9.55358 14.7414 9.56958 14.7414 9.59091C14.7414 9.61758 14.7574 9.63358 14.7734 9.63358H15.68C15.696 9.63358 15.712 9.61758 15.712 9.59091C15.712 9.56958 15.696 9.55358 15.6747 9.55358H15.68Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.3494 9.54831C15.3494 9.37231 15.2267 9.32431 15.2267 9.32431C15.2267 9.32431 15.1041 9.37764 15.1041 9.54831H15.3494ZM15.6587 9.0683H14.7894C14.7734 9.0683 14.7574 9.08964 14.7574 9.11097C14.7574 9.12697 14.7734 9.14297 14.7894 9.14297H15.6587C15.6747 9.14297 15.6907 9.12697 15.6907 9.10564C15.6907 9.08964 15.6747 9.07364 15.6587 9.07364V9.0683ZM15.6374 9.14831H14.8161C14.8001 9.14831 14.7841 9.1643 14.7841 9.18564C14.7841 9.20697 14.8001 9.22297 14.8161 9.22297H15.6427C15.6641 9.22297 15.6747 9.20697 15.6747 9.18564C15.6747 9.1643 15.6641 9.14831 15.6427 9.14831H15.6374ZM15.3707 8.58297H15.3067V8.62564H15.2587V8.58297H15.1894V8.63097H15.1414V8.57764H15.0774V8.6843C15.0774 8.70564 15.0881 8.7163 15.1041 8.7163H15.3387C15.3547 8.7163 15.3707 8.70564 15.3707 8.68964V8.58297ZM15.1254 8.72697L15.1094 9.0683H15.3387L15.3227 8.72164H15.1254"
        fill="#FFFF00"
      />
      <path
        d="M15.1254 8.72697L15.1094 9.0683H15.3387L15.3227 8.72164H15.1254M15.3494 9.54831C15.3494 9.37231 15.2267 9.32431 15.2267 9.32431C15.2267 9.32431 15.1041 9.37764 15.1041 9.54831H15.3494ZM15.6587 9.0683H14.7894C14.7734 9.0683 14.7574 9.08964 14.7574 9.11097C14.7574 9.12697 14.7734 9.14297 14.7894 9.14297H15.6587C15.6747 9.14297 15.6907 9.12697 15.6907 9.10564C15.6907 9.08964 15.6747 9.07364 15.6587 9.07364V9.0683ZM15.6374 9.14831H14.8161C14.8001 9.14831 14.7841 9.1643 14.7841 9.18564C14.7841 9.20697 14.8001 9.22297 14.8161 9.22297H15.6427C15.6641 9.22297 15.6747 9.20697 15.6747 9.18564C15.6747 9.1643 15.6641 9.14831 15.6427 9.14831H15.6374ZM15.3707 8.58297H15.3067V8.62564H15.2587V8.58297H15.1894V8.63097H15.1414V8.57764H15.0774V8.6843C15.0774 8.70564 15.0881 8.7163 15.1041 8.7163H15.3387C15.3547 8.7163 15.3707 8.70564 15.3707 8.68964V8.58297Z"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.4028 8.88696V9.0683H15.6161V8.88696H15.4028Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M14.8374 8.88696V9.0683H15.0507V8.88696H14.8374Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.6534 8.74829H15.5894V8.80162H15.5414V8.74829H15.4774V8.80162H15.4294V8.74829H15.3654V8.85496C15.3654 8.87629 15.3761 8.88696 15.3921 8.88696H15.6214C15.6299 8.88696 15.6381 8.88359 15.6441 8.87759C15.6501 8.87158 15.6534 8.86344 15.6534 8.85496V8.74829Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.0881 8.74829H15.0241V8.80162H14.9761V8.74829H14.9121V8.80162H14.8641V8.74829H14.8001V8.85496C14.8001 8.87629 14.8107 8.88696 14.8267 8.88696H15.0561C15.0646 8.88696 15.0727 8.88359 15.0787 8.87759C15.0847 8.87158 15.0881 8.86344 15.0881 8.85496V8.74829Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.2481 8.83369C15.2481 8.80169 15.2001 8.80169 15.2001 8.83369V8.91903H15.2481V8.83369Z"
        fill="#000001"
      />
      <path
        d="M15.5308 8.951C15.5308 8.919 15.4881 8.919 15.4881 8.951V9.015H15.5308V8.951Z"
        fill="#000001"
      />
      <path
        d="M14.9654 8.951C14.9654 8.919 14.9227 8.919 14.9227 8.951V9.015H14.9654V8.951Z"
        fill="#000001"
      />
      <path
        d="M15.4454 12.0389C15.4401 11.7456 15.2321 11.6763 15.2321 11.6763C15.2268 11.6763 15.0028 11.7509 15.0028 12.0443L15.4454 12.0389Z"
        fill="#FFFF00"
      />
      <path
        d="M15.6267 11.6816L15.664 12.0176H15.44C15.44 11.7403 15.2267 11.6976 15.2267 11.6976C15.2214 11.6976 15.0134 11.7563 15.008 12.0176H14.784L14.8267 11.6763L15.6267 11.6816ZM15.68 12.0229H14.7734C14.7574 12.0229 14.7414 12.0389 14.7414 12.0603C14.7414 12.0869 14.7574 12.1029 14.7734 12.1029H15.68C15.696 12.1029 15.712 12.0869 15.712 12.0603C15.712 12.0389 15.696 12.0229 15.6747 12.0229H15.68Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.3494 12.0177C15.3494 11.8417 15.2267 11.7937 15.2267 11.7937C15.2267 11.7937 15.1041 11.847 15.1041 12.0177H15.3494ZM15.6587 11.5377H14.7894C14.7734 11.5377 14.7574 11.559 14.7574 11.5803C14.7574 11.5963 14.7734 11.6123 14.7894 11.6123H15.6587C15.6747 11.6123 15.6907 11.5963 15.6907 11.575C15.6907 11.559 15.6747 11.543 15.6587 11.543V11.5377ZM15.6374 11.6177H14.8161C14.8001 11.6177 14.7841 11.6337 14.7841 11.655C14.7841 11.6763 14.8001 11.6923 14.8161 11.6923H15.6427C15.6641 11.6923 15.6747 11.6763 15.6747 11.655C15.6747 11.6337 15.6641 11.6177 15.6427 11.6177H15.6374ZM15.3707 11.0523H15.3067V11.095H15.2587V11.0523H15.1894V11.1003H15.1414V11.047H15.0774V11.1537C15.0774 11.175 15.0881 11.1857 15.1041 11.1857H15.3387C15.3547 11.1857 15.3707 11.175 15.3707 11.159V11.0523ZM15.1254 11.1963L15.1094 11.5377H15.3387L15.3227 11.191H15.1254"
        fill="#FFFF00"
      />
      <path
        d="M15.1254 11.1963L15.1094 11.5377H15.3387L15.3227 11.191H15.1254M15.3494 12.0177C15.3494 11.8417 15.2267 11.7937 15.2267 11.7937C15.2267 11.7937 15.1041 11.847 15.1041 12.0177H15.3494ZM15.6587 11.5377H14.7894C14.7734 11.5377 14.7574 11.559 14.7574 11.5803C14.7574 11.5963 14.7734 11.6123 14.7894 11.6123H15.6587C15.6747 11.6123 15.6907 11.5963 15.6907 11.575C15.6907 11.559 15.6747 11.543 15.6587 11.543V11.5377ZM15.6374 11.6177H14.8161C14.8001 11.6177 14.7841 11.6337 14.7841 11.655C14.7841 11.6763 14.8001 11.6923 14.8161 11.6923H15.6427C15.6641 11.6923 15.6747 11.6763 15.6747 11.655C15.6747 11.6337 15.6641 11.6177 15.6427 11.6177H15.6374ZM15.3707 11.0523H15.3067V11.095H15.2587V11.0523H15.1894V11.1003H15.1414V11.047H15.0774V11.1537C15.0774 11.175 15.0881 11.1857 15.1041 11.1857H15.3387C15.3547 11.1857 15.3707 11.175 15.3707 11.159V11.0523Z"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.4028 11.3563V11.5377H15.6161V11.3563H15.4028Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M14.8374 11.3563V11.5377H15.0507V11.3563H14.8374Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.6534 11.2177H15.5894V11.271H15.5414V11.2177H15.4774V11.271H15.4294V11.2177H15.3654V11.3243C15.3654 11.3457 15.3761 11.3563 15.3921 11.3563H15.6214C15.6299 11.3563 15.6381 11.3529 15.6441 11.3469C15.6501 11.3409 15.6534 11.3328 15.6534 11.3243V11.2177Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.088 11.2177H15.024V11.271H14.976V11.2177H14.912V11.271H14.864V11.2177H14.8V11.3243C14.8 11.3457 14.8107 11.3563 14.8267 11.3563H15.056C15.0645 11.3563 15.0726 11.3529 15.0786 11.3469C15.0846 11.3409 15.088 11.3328 15.088 11.3243V11.2177Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.248 11.3031C15.248 11.2711 15.2 11.2711 15.2 11.3031V11.3884H15.248V11.3031Z"
        fill="#000001"
      />
      <path
        d="M15.5307 11.4202C15.5307 11.3882 15.488 11.3882 15.488 11.4202V11.4842H15.5307V11.4202Z"
        fill="#000001"
      />
      <path
        d="M14.9654 11.4202C14.9654 11.3882 14.9227 11.3882 14.9227 11.4202V11.4842H14.9654V11.4202Z"
        fill="#000001"
      />
      <path
        d="M14.4829 14.6126C14.6873 14.4021 14.5899 14.2057 14.5899 14.2057C14.5862 14.2019 14.3753 14.0956 14.1672 14.3023L14.4829 14.6126Z"
        fill="#FFFF00"
      />
      <path
        d="M14.8642 14.4895L14.6521 14.7527L14.4942 14.5938C14.691 14.3984 14.571 14.2169 14.571 14.2169C14.5672 14.2131 14.379 14.1069 14.1898 14.2872L14.032 14.1283L14.3043 13.9181L14.8642 14.4895ZM14.6596 14.7678L14.0207 14.1245C14.0094 14.1131 13.9868 14.1131 13.9717 14.1281C13.9527 14.1469 13.9527 14.1695 13.9639 14.1809L14.6028 14.8242C14.6141 14.8356 14.6367 14.8356 14.6556 14.8168C14.6708 14.8018 14.6708 14.7792 14.6558 14.764L14.6596 14.7678Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M14.4304 14.5294C14.5553 14.4054 14.5029 14.2845 14.5029 14.2845C14.5029 14.2845 14.3786 14.2351 14.2575 14.3553L14.4304 14.5294ZM14.989 14.4107L14.3764 13.7938C14.3651 13.7825 14.3387 13.7862 14.3236 13.8012C14.3122 13.8125 14.3121 13.8351 14.3234 13.8464L14.936 14.4633C14.9473 14.4746 14.9699 14.4747 14.985 14.4597C14.9964 14.4484 14.9965 14.4258 14.9852 14.4144L14.989 14.4107ZM14.9172 14.4519L14.3384 13.8691C14.3272 13.8578 14.3045 13.8577 14.2894 13.8727C14.2743 13.8878 14.2742 13.9104 14.2854 13.9217L14.8679 14.5083C14.883 14.5234 14.9018 14.5197 14.917 14.5047C14.9321 14.4897 14.936 14.4708 14.9209 14.4557L14.9172 14.4519ZM15.1304 13.8643L15.0853 13.8189L15.055 13.849L15.0212 13.8149L15.0515 13.7849L15.0026 13.7357L14.9686 13.7695L14.9348 13.7354L14.9726 13.6979L14.9275 13.6524L14.8518 13.7276C14.8367 13.7426 14.8366 13.7577 14.8479 13.7691L15.0133 13.9356C15.0245 13.9469 15.0434 13.9508 15.0547 13.9395L15.1304 13.8643ZM14.8554 13.7917L14.6019 14.0209L14.7635 14.1836L14.9982 13.928L14.8591 13.788"
        fill="#FFFF00"
      />
      <path
        d="M14.8554 13.7917L14.6019 14.0209L14.7635 14.1836L14.9982 13.928L14.8591 13.788M14.4304 14.5294C14.5553 14.4054 14.5029 14.2845 14.5029 14.2845C14.5029 14.2845 14.3786 14.2351 14.2575 14.3553L14.4304 14.5294ZM14.989 14.4107L14.3764 13.7938C14.3651 13.7825 14.3387 13.7862 14.3236 13.8012C14.3122 13.8125 14.3121 13.8351 14.3234 13.8464L14.936 14.4633C14.9473 14.4746 14.9699 14.4747 14.985 14.4597C14.9964 14.4484 14.9965 14.4258 14.9852 14.4144L14.989 14.4107ZM14.9172 14.4519L14.3384 13.8691C14.3272 13.8578 14.3045 13.8577 14.2894 13.8727C14.2743 13.8878 14.2742 13.9104 14.2854 13.9217L14.8679 14.5083C14.883 14.5234 14.9018 14.5197 14.917 14.5047C14.9321 14.4897 14.936 14.4708 14.9209 14.4557L14.9172 14.4519ZM15.1304 13.8643L15.0853 13.8189L15.055 13.849L15.0212 13.8149L15.0515 13.7849L15.0026 13.7357L14.9686 13.7695L14.9348 13.7354L14.9726 13.6979L14.9275 13.6524L14.8518 13.7276C14.8367 13.7426 14.8366 13.7577 14.8479 13.7691L15.0133 13.9356C15.0245 13.9469 15.0434 13.9508 15.0547 13.9395L15.1304 13.8643Z"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M14.9372 14.1013L14.8085 14.2291L14.9589 14.3805L15.0875 14.2527L14.9372 14.1013Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M14.5389 13.7002L14.4102 13.828L14.5605 13.9793L14.6892 13.8516L14.5389 13.7002Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M15.2123 14.1814L15.1672 14.136L15.1293 14.1736L15.0955 14.1395L15.1334 14.1019L15.0883 14.0565L15.0504 14.0941L15.0166 14.06L15.0544 14.0225L15.0093 13.977L14.9337 14.0522C14.9185 14.0672 14.9185 14.0823 14.9297 14.0937L15.0913 14.2564C15.0973 14.2624 15.1054 14.2658 15.1139 14.2659C15.1224 14.2659 15.1306 14.2625 15.1366 14.2566L15.2123 14.1814Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M14.8139 13.7803L14.7688 13.7349L14.731 13.7724L14.6971 13.7384L14.735 13.7008L14.6899 13.6554L14.652 13.693L14.6182 13.6589L14.6561 13.6213L14.611 13.5759L14.5353 13.6511C14.5201 13.6661 14.5201 13.6812 14.5314 13.6925L14.693 13.8553C14.6989 13.8613 14.7071 13.8647 14.7156 13.8647C14.724 13.8648 14.7322 13.8614 14.7382 13.8554L14.8139 13.7803Z"
        fill="#FFFF00"
        stroke="black"
        strokeWidth="0.0266667"
      />
      <path
        d="M14.8661 13.954C14.8889 13.9315 14.855 13.8974 14.8323 13.92L14.7718 13.9801L14.8056 14.0142L14.8661 13.954Z"
        fill="#000001"
      />
      <path
        d="M14.9821 14.2372C15.0048 14.2147 14.9747 14.1844 14.952 14.207L14.9066 14.2521L14.9366 14.2823L14.9821 14.2372Z"
        fill="#000001"
      />
      <path
        d="M14.5837 13.836C14.6064 13.8135 14.5763 13.7832 14.5536 13.8057L14.5082 13.8508L14.5383 13.8811L14.5837 13.836Z"
        fill="#000001"
      />
      <path
        d="M12.4054 12.1296C12.4044 12.2422 12.4464 12.3509 12.5227 12.4336C12.5584 12.4734 12.6019 12.5054 12.6506 12.5274C12.6992 12.5495 12.752 12.5611 12.8054 12.5616C12.9174 12.5616 13.0187 12.5083 13.0881 12.4336C13.1644 12.3509 13.2064 12.2422 13.2054 12.1296V11.5536H12.4054V12.1296Z"
        fill="#003399"
      />
      <path
        d="M12.5921 11.8523C12.6363 11.8523 12.6721 11.8164 12.6721 11.7723C12.6721 11.7281 12.6363 11.6923 12.5921 11.6923C12.5479 11.6923 12.5121 11.7281 12.5121 11.7723C12.5121 11.8164 12.5479 11.8523 12.5921 11.8523Z"
        fill="white"
      />
      <path
        d="M13.0347 11.8523C13.0789 11.8523 13.1147 11.8164 13.1147 11.7723C13.1147 11.7281 13.0789 11.6923 13.0347 11.6923C12.9905 11.6923 12.9547 11.7281 12.9547 11.7723C12.9547 11.8164 12.9905 11.8523 13.0347 11.8523Z"
        fill="white"
      />
      <path
        d="M12.8107 12.0655C12.8549 12.0655 12.8907 12.0297 12.8907 11.9855C12.8907 11.9413 12.8549 11.9055 12.8107 11.9055C12.7665 11.9055 12.7307 11.9413 12.7307 11.9855C12.7307 12.0297 12.7665 12.0655 12.8107 12.0655Z"
        fill="white"
      />
      <path
        d="M12.5921 12.2896C12.6363 12.2896 12.6721 12.2538 12.6721 12.2096C12.6721 12.1655 12.6363 12.1296 12.5921 12.1296C12.5479 12.1296 12.5121 12.1655 12.5121 12.2096C12.5121 12.2538 12.5479 12.2896 12.5921 12.2896Z"
        fill="white"
      />
      <path
        d="M13.0347 12.2896C13.0789 12.2896 13.1147 12.2538 13.1147 12.2096C13.1147 12.1655 13.0789 12.1296 13.0347 12.1296C12.9905 12.1296 12.9547 12.1655 12.9547 12.2096C12.9547 12.2538 12.9905 12.2896 13.0347 12.2896Z"
        fill="white"
      />
      <path
        d="M12.4054 10.743C12.4044 10.8556 12.4464 10.9643 12.5227 11.047C12.5584 11.0868 12.6019 11.1188 12.6506 11.1408C12.6992 11.1629 12.752 11.1745 12.8054 11.175C12.9174 11.175 13.0187 11.1217 13.0881 11.047C13.1644 10.9643 13.2064 10.8556 13.2054 10.743V10.167H12.4054V10.743Z"
        fill="#003399"
      />
      <path
        d="M12.5921 10.4657C12.6363 10.4657 12.6721 10.4298 12.6721 10.3857C12.6721 10.3415 12.6363 10.3057 12.5921 10.3057C12.5479 10.3057 12.5121 10.3415 12.5121 10.3857C12.5121 10.4298 12.5479 10.4657 12.5921 10.4657Z"
        fill="white"
      />
      <path
        d="M13.0347 10.4657C13.0789 10.4657 13.1147 10.4298 13.1147 10.3857C13.1147 10.3415 13.0789 10.3057 13.0347 10.3057C12.9905 10.3057 12.9547 10.3415 12.9547 10.3857C12.9547 10.4298 12.9905 10.4657 13.0347 10.4657Z"
        fill="white"
      />
      <path
        d="M12.8107 10.6789C12.8549 10.6789 12.8907 10.6431 12.8907 10.5989C12.8907 10.5547 12.8549 10.5189 12.8107 10.5189C12.7665 10.5189 12.7307 10.5547 12.7307 10.5989C12.7307 10.6431 12.7665 10.6789 12.8107 10.6789Z"
        fill="white"
      />
      <path
        d="M12.5921 10.9029C12.6363 10.9029 12.6721 10.8671 12.6721 10.8229C12.6721 10.7787 12.6363 10.7429 12.5921 10.7429C12.5479 10.7429 12.5121 10.7787 12.5121 10.8229C12.5121 10.8671 12.5479 10.9029 12.5921 10.9029Z"
        fill="white"
      />
      <path
        d="M13.0347 10.9029C13.0789 10.9029 13.1147 10.8671 13.1147 10.8229C13.1147 10.7787 13.0789 10.7429 13.0347 10.7429C12.9905 10.7429 12.9547 10.7787 12.9547 10.8229C12.9547 10.8671 12.9905 10.9029 13.0347 10.9029Z"
        fill="white"
      />
      <path
        d="M11.296 12.1296C11.2951 12.2422 11.337 12.3509 11.4134 12.4336C11.449 12.4734 11.4925 12.5054 11.5412 12.5274C11.5899 12.5495 11.6426 12.5611 11.696 12.5616C11.808 12.5616 11.9094 12.5083 11.9787 12.4336C12.055 12.3509 12.097 12.2422 12.096 12.1296V11.5536H11.296V12.1296Z"
        fill="#003399"
      />
      <path
        d="M11.4827 11.8523C11.5269 11.8523 11.5627 11.8164 11.5627 11.7723C11.5627 11.7281 11.5269 11.6923 11.4827 11.6923C11.4385 11.6923 11.4027 11.7281 11.4027 11.7723C11.4027 11.8164 11.4385 11.8523 11.4827 11.8523Z"
        fill="white"
      />
      <path
        d="M11.9253 11.8523C11.9695 11.8523 12.0053 11.8164 12.0053 11.7723C12.0053 11.7281 11.9695 11.6923 11.9253 11.6923C11.8812 11.6923 11.8453 11.7281 11.8453 11.7723C11.8453 11.8164 11.8812 11.8523 11.9253 11.8523Z"
        fill="white"
      />
      <path
        d="M11.7013 12.0655C11.7455 12.0655 11.7813 12.0297 11.7813 11.9855C11.7813 11.9413 11.7455 11.9055 11.7013 11.9055C11.6572 11.9055 11.6213 11.9413 11.6213 11.9855C11.6213 12.0297 11.6572 12.0655 11.7013 12.0655Z"
        fill="white"
      />
      <path
        d="M11.4827 12.2896C11.5269 12.2896 11.5627 12.2538 11.5627 12.2096C11.5627 12.1655 11.5269 12.1296 11.4827 12.1296C11.4385 12.1296 11.4027 12.1655 11.4027 12.2096C11.4027 12.2538 11.4385 12.2896 11.4827 12.2896Z"
        fill="white"
      />
      <path
        d="M11.9253 12.2896C11.9695 12.2896 12.0053 12.2538 12.0053 12.2096C12.0053 12.1655 11.9695 12.1296 11.9253 12.1296C11.8812 12.1296 11.8453 12.1655 11.8453 12.2096C11.8453 12.2538 11.8812 12.2896 11.9253 12.2896Z"
        fill="white"
      />
      <path
        d="M13.5147 12.1296C13.5138 12.2422 13.5557 12.3509 13.6321 12.4336C13.6677 12.4734 13.7112 12.5054 13.7599 12.5274C13.8086 12.5495 13.8613 12.5611 13.9147 12.5616C14.0267 12.5616 14.1281 12.5083 14.1974 12.4336C14.2737 12.3509 14.3157 12.2422 14.3147 12.1296V11.5536H13.5147V12.1296Z"
        fill="#003399"
      />
      <path
        d="M13.7014 11.8523C13.7456 11.8523 13.7814 11.8164 13.7814 11.7723C13.7814 11.7281 13.7456 11.6923 13.7014 11.6923C13.6572 11.6923 13.6214 11.7281 13.6214 11.7723C13.6214 11.8164 13.6572 11.8523 13.7014 11.8523Z"
        fill="white"
      />
      <path
        d="M14.1441 11.8523C14.1883 11.8523 14.2241 11.8164 14.2241 11.7723C14.2241 11.7281 14.1883 11.6923 14.1441 11.6923C14.0999 11.6923 14.0641 11.7281 14.0641 11.7723C14.0641 11.8164 14.0999 11.8523 14.1441 11.8523Z"
        fill="white"
      />
      <path
        d="M13.92 12.0655C13.9642 12.0655 14 12.0297 14 11.9855C14 11.9413 13.9642 11.9055 13.92 11.9055C13.8758 11.9055 13.84 11.9413 13.84 11.9855C13.84 12.0297 13.8758 12.0655 13.92 12.0655Z"
        fill="white"
      />
      <path
        d="M13.7014 12.2896C13.7456 12.2896 13.7814 12.2538 13.7814 12.2096C13.7814 12.1655 13.7456 12.1296 13.7014 12.1296C13.6572 12.1296 13.6214 12.1655 13.6214 12.2096C13.6214 12.2538 13.6572 12.2896 13.7014 12.2896Z"
        fill="white"
      />
      <path
        d="M14.1441 12.2896C14.1883 12.2896 14.2241 12.2538 14.2241 12.2096C14.2241 12.1655 14.1883 12.1296 14.1441 12.1296C14.0999 12.1296 14.0641 12.1655 14.0641 12.2096C14.0641 12.2538 14.0999 12.2896 14.1441 12.2896Z"
        fill="white"
      />
      <path
        d="M12.4054 13.5057C12.4044 13.6183 12.4464 13.727 12.5227 13.8097C12.5584 13.8495 12.6019 13.8815 12.6506 13.9035C12.6992 13.9256 12.752 13.9372 12.8054 13.9377C12.9174 13.9377 13.0187 13.8844 13.0881 13.8097C13.1644 13.727 13.2064 13.6183 13.2054 13.5057V12.9297H12.4054V13.5057Z"
        fill="#003399"
      />
      <path
        d="M12.5921 13.2284C12.6363 13.2284 12.6721 13.1925 12.6721 13.1484C12.6721 13.1042 12.6363 13.0684 12.5921 13.0684C12.5479 13.0684 12.5121 13.1042 12.5121 13.1484C12.5121 13.1925 12.5479 13.2284 12.5921 13.2284Z"
        fill="white"
      />
      <path
        d="M13.0347 13.2284C13.0789 13.2284 13.1147 13.1925 13.1147 13.1484C13.1147 13.1042 13.0789 13.0684 13.0347 13.0684C12.9905 13.0684 12.9547 13.1042 12.9547 13.1484C12.9547 13.1925 12.9905 13.2284 13.0347 13.2284Z"
        fill="white"
      />
      <path
        d="M12.8107 13.4416C12.8549 13.4416 12.8907 13.4058 12.8907 13.3616C12.8907 13.3174 12.8549 13.2816 12.8107 13.2816C12.7665 13.2816 12.7307 13.3174 12.7307 13.3616C12.7307 13.4058 12.7665 13.4416 12.8107 13.4416Z"
        fill="white"
      />
      <path
        d="M12.5921 13.6656C12.6363 13.6656 12.6721 13.6298 12.6721 13.5856C12.6721 13.5414 12.6363 13.5056 12.5921 13.5056C12.5479 13.5056 12.5121 13.5414 12.5121 13.5856C12.5121 13.6298 12.5479 13.6656 12.5921 13.6656Z"
        fill="white"
      />
      <path
        d="M13.0347 13.6656C13.0789 13.6656 13.1147 13.6298 13.1147 13.5856C13.1147 13.5414 13.0789 13.5056 13.0347 13.5056C12.9905 13.5056 12.9547 13.5414 12.9547 13.5856C12.9547 13.6298 12.9905 13.6656 13.0347 13.6656Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9104_10924">
        <rect fill="white" height="24" width="32" />
      </clipPath>
    </defs>
  </svg>
)
